var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBulletLinesL(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.512.84L8.928.12.288 18.36l1.584.672L10.512.84zm7.266 0L16.194.12l-8.64 18.24 1.584.672L17.778.84z",
    fill: "#CE1212"
  })));
}

var MemoSvgBulletLinesL = /*#__PURE__*/React.memo(SvgBulletLinesL);
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTggMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMC41MTIgMC44Mzk5OTlMOC45MjggMC4xMTk5OThMMC4yODggMTguMzZMMS44NzIgMTkuMDMyTDEwLjUxMiAwLjgzOTk5OVpNMTcuNzc3NiAwLjgzOTk5OUwxNi4xOTM2IDAuMTE5OTk4TDcuNTUzNjMgMTguMzZMOS4xMzc2MyAxOS4wMzJMMTcuNzc3NiAwLjgzOTk5OVoiIGZpbGw9IiNDRTEyMTIiLz4KPC9zdmc+Cg==";
export { MemoSvgBulletLinesL as ReactComponent };